import Vue from 'vue';

import grid from './grid.vue';
Vue.component('mag-grid', grid);